import { render, staticRenderFns } from "./SignatureTemplate.vue?vue&type=template&id=35617043&scoped=true"
import script from "./SignatureTemplate.vue?vue&type=script&lang=js"
export * from "./SignatureTemplate.vue?vue&type=script&lang=js"
import style0 from "./SignatureTemplate.vue?vue&type=style&index=0&id=35617043&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35617043",
  null
  
)

export default component.exports